import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { ServiceOrderService } from '../../service-orders/crud-service';
import {
  CustomerServiceOrderRow,
  serviceOrderBelongsToCustomer,
  toCustomerServiceOrderRow,
  unwrapListResponse,
} from '../customer-related/customer-related.util';

@Component({
  selector: 'app-customer-os-list',
  templateUrl: './customer-os-list.component.html',
  styleUrls: ['./customer-os-list.component.sass'],
})
export class CustomerOsListComponent implements OnChanges {
  @Input() customerId: string | null = null;

  rows: CustomerServiceOrderRow[] = [];
  loading = false;
  displayedColumns = ['code', 'title', 'type', 'status', 'createdAt'];

  constructor(
    private serviceOrderService: ServiceOrderService,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customerId']) {
      this.load();
    }
  }

  load(): void {
    if (!this.customerId) {
      this.rows = [];
      this.loading = false;
      return;
    }
    this.loading = true;
    this.fetch(true);
  }

  open(row: CustomerServiceOrderRow): void {
    if (!row?.id) return;
    this.router.navigate(['/service-orders/view', row.id]);
  }

  private fetch(withCustomerFilter: boolean): void {
    const params: Record<string, string | number> = {
      limit: 500,
      page: 0,
      filter: '',
      getRelation: 1,
    };
    if (withCustomerFilter && this.customerId) {
      params['customerId'] = this.customerId;
    }

    this.serviceOrderService
      .listAll(params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.rows = unwrapListResponse(response)
            .filter((order) => serviceOrderBelongsToCustomer(order, this.customerId || ''))
            .map(toCustomerServiceOrderRow);
          this.loading = false;
        },
        error: () => {
          if (withCustomerFilter) {
            this.fetch(false);
            return;
          }
          this.rows = [];
          this.loading = false;
          this.toastService.showWarn('Não foi possível carregar as OS deste cliente.');
        },
      });
  }
}
